import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'

export const mockGetPaymentDetailsIframeUrlSuccess = (
  externalId: string,
  url = 'www.example.com/iframe'
) => {
  return rest.post(
    `/api/v3/pay/cards/${externalId}/sensitive-card-details-iframe-url/`,
    (_, res, ctx) => {
      return res.once(ctx.status(200), ctx.json(getResponseObject({ url })))
    }
  )
}

export const mockGetPaymentDetailsIframeUrlError = (
  externalId: string,
  errorStatusCode = 400,
  scaSessionCode = 'sca_session_code_12345'
) => {
  return rest.post(
    `/api/v3/pay/cards/${externalId}/sensitive-card-details-iframe-url/`,
    (_, res, ctx) => {
      if (errorStatusCode === 403) {
        return res(
          ctx.set('x-sca-session-code', scaSessionCode),
          ctx.status(403)
        )
      }
      return res.once(ctx.status(errorStatusCode))
    }
  )
}
